import React from 'react';
import { router } from 'shared/router';
import { routeBuilder } from 'shared/router';

interface ErrorBoundaryPropsType {
  children: JSX.Element;
}

interface ErrorBoundaryStateType {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<ErrorBoundaryPropsType, ErrorBoundaryStateType> {
  constructor(props: ErrorBoundaryPropsType) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      router.navigate(routeBuilder.error());
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
